import { Box, Flex, Image } from "@chakra-ui/react";
import { IoLogoWhatsapp } from "react-icons/io";
import Footer from "./footer";
import Navbar from "./navbar";
const PublicLayout = ({ children, color, bg, register = true, type }) => {
  return (
    <Box
      w="100%"
      className="public"
      overflowX="hidden"
      justifyContent="space-between"
    >
      <Image
        src={require("../../../assets/Vector 6.jpg")}
        position="absolute"
        zIndex="-1"
        left="-80px"
      />
      <Box h="100px" w="100%">
        <Navbar color={color} bg={bg} register={register} type={type} />
      </Box>
      <Image
        src={require("../../../assets/Vector.jpg")}
        position="absolute"
        right="-80px"
        top=" 25%"
        zIndex="-1"
        display={{ base: "none", md: "block" }}
      />
      {children}

      <Footer />
      <a href="http://wa.me/+201280666045" target="_blank" rel="noreferrer">
        <Flex
          position="fixed"
          bottom={1}
          left={2}
          borderRadius="full"
          bg="#075e5436"
          alignItems="center"
        >
          <Box bg="white"></Box>
          <IoLogoWhatsapp size={50} color="#075E54" />
        </Flex>
      </a>
    </Box>
  );
};

export default PublicLayout;
